import React, { FC } from 'react';

import Flex from '../../../Flex';
import { useAppLayoutGutterSize, useContentMaxWidth } from '../../hooks';

import { getClassNames } from './MainAreaRowContent.styles';

const MainAreaRowContent: FC = ({ children }) => {
  const contentMaxWidth = useContentMaxWidth();
  const gutterSize = useAppLayoutGutterSize();
  const classNames = getClassNames();

  return (
    <Flex
      minWidth="auto"
      direction="column"
      rowGap={gutterSize}
      height="100%"
      maxWidth={contentMaxWidth}
      className={classNames.mainAreaRowContent}
    >
      {children}
    </Flex>
  );
};

export default MainAreaRowContent;
